import React from 'react';
import {RouteComponentProps} from 'react-router-dom';
import VodInfoContainer from 'containers/VodInfoContainer';
import HeaderContainer from 'containers/common/HeaderContainer';
import Footer from 'components/common/Footer';

/**
 * 웹 편집기 페이지
 */

interface IMatchParams {
  titleNo: string;
}

const WebEditPage = ({match}: RouteComponentProps<IMatchParams>) => {
  const {titleNo} = match.params;
  const title_no = Number(titleNo) || 0;

  return (
    <>
      <HeaderContainer />
      <VodInfoContainer titleNo={title_no} mode='web' />
      <Footer />
    </>
  );
};

export default WebEditPage;
